module.exports = __webpack_public_path__ + "assets/img/welcome-qes.146543bf.png";